import { handleActions, combineActions } from 'redux-actions'

import * as rawActions from '../../actions'

const defaultState = false

export default handleActions(
  {
    [combineActions(rawActions.openAttachAiModelDialog)]() {
      return true
    },
    [combineActions(rawActions.addPredictionSet.request, rawActions.resetState, rawActions.closeAttachModelDialog)]() {
      return defaultState
    },
  },
  defaultState
)
